import { useEffect, useReducer } from 'react';
import { getSignInEmailFromDom } from './get-sign-in-email-from-dom';

export const useSignInEmailFromDom = (enabled: boolean): string => {
  const [, bump] = useReducer((n: number) => n + 1, 0);

  useEffect(() => {
    if (!enabled || typeof document === 'undefined') {
      return;
    }
    const onFormInteraction = (event: Event) => {
      const target = event.target;
      if (!(target instanceof HTMLElement)) {
        return;
      }
      const form = target.closest('form[data-amplify-authenticator-signin]');
      if (form) {
        bump();
      }
    };
    document.addEventListener('input', onFormInteraction, true);
    document.addEventListener('change', onFormInteraction, true);
    return () => {
      document.removeEventListener('input', onFormInteraction, true);
      document.removeEventListener('change', onFormInteraction, true);
    };
  }, [enabled]);

  return enabled ? getSignInEmailFromDom() : '';
};
